import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-background-50">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mx-auto mb-6">
          <i className="ri-error-warning-line text-foreground-400 text-2xl"></i>
        </div>
        <h1 className="font-heading text-5xl md:text-6xl font-bold text-foreground-950 mb-4">404</h1>
        <p className="font-body text-lg text-foreground-600 mb-8">
          Strona, której szukasz, nie istnieje.
          <br />
          Wróć do strony głównej i kontynuuj eksplorację <strong className="text-accent-600">Kakobuy Spreadsheet</strong>.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          Strona Główna
        </Link>
      </div>
    </div>
  );
}